'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _discoverItems = require('../../redux/modules/discoverItems');

var _categoryGrabber = require('../../utils/categoryGrabber');

var _Link = require('../Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DiscoveryTags = require('./DiscoveryTags.scss');

var _DiscoveryTags2 = _interopRequireDefault(_DiscoveryTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscoverTags = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(DiscoverTags, _Component);

    function DiscoverTags() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DiscoverTags);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscoverTags.__proto__ || (0, _getPrototypeOf2.default)(DiscoverTags)).call.apply(_ref, [this].concat(args))), _this), _this.createCategoryLandingLink = function (mainItem, secondItem) {
            mainItem = (0, _categoryGrabber.getCategoryLevel)(mainItem);
            secondItem = (0, _categoryGrabber.getCategoryLevel)(secondItem);
            var isTwoItems = secondItem.categoryUrl;

            var key = isTwoItems ? mainItem.categoryLabel + '-' + secondItem.categoryLabel : '' + mainItem.categoryLabel;

            var link = isTwoItems ? '/c/' + mainItem.categoryUrl + '/' + secondItem.categoryUrl + '/' + mainItem.categoryId + '/' + secondItem.categoryId + '/' : '/c/' + mainItem.categoryUrl + '/' + mainItem.categoryId + '/';

            var name = isTwoItems ? secondItem.categoryLabel + ' ' + mainItem.categoryLabel : '' + mainItem.categoryLabel;

            return (0, _jsx3.default)('div', {}, key, (0, _jsx3.default)(_Link2.default, {
                route: true,
                className: _DiscoveryTags2.default['tag-link'],
                to: link
            }, void 0, name));
        }, _this.getColorIndex = function (index) {
            return index % DiscoverTags.colorArr.length;
        }, _this.getColorClasses = function (index) {
            return (0, _classnames2.default)(_DiscoveryTags2.default.tag, _DiscoveryTags2.default[DiscoverTags.colorArr[_this.getColorIndex(index)] + '-tag']);
        }, _this.mapToTags = function (link, index) {
            return (0, _jsx3.default)('div', {
                className: _this.getColorClasses(index)
            }, index, link);
        }, _this.mapToDefaultTags = function (tag, index) {
            return (0, _jsx3.default)('div', {
                className: _this.getColorClasses(index)
            }, index + '-' + tag.name, (0, _jsx3.default)(_Link2.default, {
                route: true,
                className: _DiscoveryTags2.default['tag-link'],
                to: tag.link
            }, void 0, tag.name));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DiscoverTags, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['facets']);
        }

        // copied and refactored from DiscoverItems.js

    }, {
        key: 'render',
        value: function render() {
            var facets = this.props.facets;

            var links = (0, _discoverItems.generateDiscoverLinks)(facets, this.createCategoryLandingLink);
            var defaultTags = DiscoverTags.defaultTags.map(this.mapToDefaultTags); // radomize the default tags

            return (0, _jsx3.default)('div', {
                className: _DiscoveryTags2.default['tags']
            }, void 0, !links.length ? defaultTags : [].concat((0, _toConsumableArray3.default)(links.map(this.mapToTags)), (0, _toConsumableArray3.default)(defaultTags)));
        }
    }]);
    return DiscoverTags;
}(_react.Component), _class.colorArr = ['red', 'blue', 'orange', 'green', 'purple'], _class.defaultTags = [{ link: '/c/coins-currency-stamps/24/', name: 'Coins' }, { link: '/c/paintings/10/', name: 'Paintings' }, { link: '/c/toys-trains-games/46/', name: 'Toys, Dolls & Games' }, { link: '/c/fashion/3/', name: 'Vintage Fashion' }, { link: '/c/watches/97/ ', name: 'Watches' }, { link: '/c/rings/96/', name: 'Rings' }, { link: '/c/weapons-armor/35/', name: 'Weapons & Armor' }, { link: '/c/photography/11/', name: 'Photography' }, { link: '/c/sculptures/14/', name: 'Sculptures' }, { link: '/c/rugs-carpets/85/', name: 'Rugs & Carpets' }, { link: '/c/clocks/74/', name: 'Clocks' }, { link: '/c/books-folios-manuscripts/25910/', name: 'Books' }, { link: '/c/art-deco/253/', name: 'Art Deco' }], _temp2);
exports.default = DiscoverTags;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DiscoveryTags/DiscoveryTags.js
// module id = JstK
// module chunks = 57